export default "__VITE_ASSET__hqCKs2jq__"